import { IconSuccess16 } from "../IconSuccess16";
import { stopPropagation } from "./utils";
import * as React from "react";
const styles = require("./index.css");

export const WorkHonestlyTooltip = () => {
  return (
    <div className={styles["container"]} onClick={stopPropagation}>
      <ul className={styles["tooltip"]}>
        <li className={styles["tooltip_item"]}>
          <IconSuccess16 />
          <span>Документы проверены</span>
        </li>
        <li className={styles["tooltip_item"]}>
          <IconSuccess16 />
          <span>Вежливо общается с клиентами</span>
        </li>
        <li className={styles["tooltip_item"]}>
          <IconSuccess16 />
          <span>Всегда отвечает на звонки и сообщения</span>
        </li>
        <li className={styles["tooltip_item"]}>
          <IconSuccess16 />
          <span>Соблюдает правила Циан</span>
        </li>
      </ul>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/bundles/honest_work/components/WorkHonestlyTooltip/index.tsx